import { connect } from 'react-redux'
import TeamMemberTable from '../../components/team-members/TeamMemberTable'
import { getMany } from '../../state/actions/team_members'
import { IStoreState, IMemberSearchObject, IMemberFilters } from '../../types'
import { recoverPassword } from 'src/state/actions/auth'
import { moveToArchive, sendInvite } from '../../state/actions/team_members/index'
import { getAllOrganizations } from '../../state/actions/organizations'
import { actionCreators } from '../../state/actions/team_members/index'

const mapStateToProps = (state: IStoreState, ownProps: any): any => {
  return {
    currentOrgId: state.organizations.currentOrgId,
    isFetching: state.teamMember.isFetching,
    teamMembers: Object.values(state.teamMember.items),
    total: state.teamMember.total,
    type: ownProps.type,
    filters: state.teamMember.filters
  }
}

const mapDispatchToProps = (dispatch: any, props: any) => {
  return {
    fetchOrgList: () => {
      return dispatch(getAllOrganizations())
    },
    updateFilters: (filters: IMemberFilters) => dispatch(actionCreators.updateTeamMemberFilters(filters)),
    fetchTeamMemberList: (filters: IMemberFilters) => {
      return dispatch(getMany(filters))
    },
    archive: (teamMember: IMemberSearchObject) => {
      return dispatch(moveToArchive(teamMember))
    },
    resetPassword: (teamMember: IMemberSearchObject) => {
      return dispatch(recoverPassword(teamMember.email))
    },
    sendInvitation: (teamMember: IMemberSearchObject) => {
      return dispatch(sendInvite(teamMember))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TeamMemberTable)



// WEBPACK FOOTER //
// ./src/containers/team-members/TeamMemberTable.ts